import { Controller } from '@hotwired/stimulus';

// Editor shell: folds the Variables drawer and bridges the header Save button
// to the TinyMCE controller via window events (see editor.js).
export default class extends Controller {
  static targets = [
    'toggleButton', 'toggleClose', 'toggleOpen',
    'saveButton', 'saveIcon', 'savingIcon',
    'status', 'statusText',
  ];

  toggleDrawer() {
    const collapsed = this.element.classList.toggle('is-drawer-collapsed');
    this.toggleButtonTarget.classList.toggle('is-active', !collapsed);
    this.toggleCloseTarget.classList.toggle('hidden', collapsed);
    this.toggleOpenTarget.classList.toggle('hidden', !collapsed);
  }

  save() {
    if (this.saving) return;
    this.saving = true;
    this.saveButtonTarget.disabled = true;
    this.saveIconTarget.classList.add('hidden');
    this.savingIconTarget.classList.remove('hidden');
    window.dispatchEvent(new CustomEvent('editor:save'));
  }

  // window "editor:saved" — fired by tinymce_editor_controller once the PUT resolves.
  onSaved() {
    this.saving = false;
    this.saveButtonTarget.disabled = false;
    this.saveIconTarget.classList.remove('hidden');
    this.savingIconTarget.classList.add('hidden');

    if (!this.hasStatusTarget) return;
    this.statusTarget.hidden = false;
    this.statusTextTarget.textContent = this.statusTarget.dataset.savedLabel || '';
  }
}
